export default function ArmadaHome() {
  return <div style={{ color: "#FFF" }}>MAKE THIS A DASHBOARD ONE DAY?</div>;
}
